<template>
    <div class="mainbusinessModuleWarp">
        <div  class="moduleTitle">人力资源培训服务</div>
        <div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position='top' :validate-on-rule-change="false">
                <div class="dialogformCenter">
                    <div class="bigTitle">一、从业人员</div>
                    <el-form-item label="  1.从业人员总数：" prop="1">
                        <el-input v-model="ruleForm[1]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="  2.本科及以上学历人数：" prop="2">
                        <el-input v-model="ruleForm[2]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="3.培训工作负责人具有本科及以上学历：" prop="3">
                        <el-radio-group v-model="ruleForm[3]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="4.研究生学历或硕士以上学历人数：" prop="4">
                        <el-input v-model="ruleForm[4]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="5.培训工作负责人具有中级以上专业技术职务任职资格或职（执）业资格：" prop="5">
                        <el-radio-group v-model="ruleForm[5]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="6.具有组织和参加教材编写的人员：" prop="6">
                        <el-radio-group v-model="ruleForm[6]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="7.具有专职教师：" prop="7">
                        <el-radio-group v-model="ruleForm[7]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">二、培训内容</div>
                    <el-form-item label="  8.开展培训内容数量：" prop="8">
                        <el-input v-model="ruleForm[8]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">三、服务场所及设施</div>
                    <el-form-item label="9.服务场所建筑面积（平方米）：" prop="9">
                        <el-input v-model="ruleForm[9]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="10.自有或租用的培训场所应符合相关规定和要求：" prop="10">
                        <el-radio-group v-model="ruleForm[10]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="11.电教设备符合培训要求：" prop="11">
                        <el-radio-group v-model="ruleForm[11]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">四、师资、教材</div>
                    <el-form-item label=" 12.聘用教师人数：" prop="12">
                        <el-input v-model="ruleForm[12]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="13.选用正式出版的教材：" prop="13">
                        <el-radio-group v-model="ruleForm[13]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="14.自编教材注明编委及作者：" prop="14">
                        <el-radio-group v-model="ruleForm[14]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="15.制作培训课程：" prop="15">
                        <el-radio-group v-model="ruleForm[15]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="16.教材和试卷由委托培训机构认可相对稳定：" prop="16">
                        <el-radio-group v-model="ruleForm[16]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label=" 17.相对稳定的教师人数：" prop="17">
                        <el-input v-model="ruleForm[17]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="18.具有专业的课程设置目录和试题库：" prop="18">
                        <el-radio-group v-model="ruleForm[18]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">五、管理制度</div>
                    <el-form-item label="19.建有培训工作规程：" prop="19">
                        <el-radio-group v-model="ruleForm[19]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label=" 20.建立教学、考试（考核）管理办法：" prop="20">
                        <el-radio-group v-model="ruleForm[20]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="21.建有教师聘任及管理制度：" prop="21">
                        <el-radio-group v-model="ruleForm[21]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="22.建有教学设施使用与管理和培训教材管理制度：" prop="22">
                        <el-radio-group v-model="ruleForm[22]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="23.有健全的安保、消防、卫生突发事件应急预案：" prop="23">
                        <el-radio-group v-model="ruleForm[23]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="24.建立质量评估与监控机制" prop="24">
                        <el-radio-group v-model="ruleForm[24]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">六、培训项目</div>
                    <el-form-item label="25.年培训项目数量：" prop="25">
                        <el-input v-model="ruleForm[25]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="26.年举办培训次数：" prop="26">
                        <el-input v-model="ruleForm[26]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="27.年培训人数：" prop="27">
                        <el-input v-model="ruleForm[27]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">七、信息化管理程度</div>
                    <el-form-item label="28.信息化管理程度" prop="28">
                        <el-select v-model="ruleForm[28]" placeholder="请选择">
                            <el-option label="A.培训与学员管理手工操作" value="A"></el-option>
                            <el-option label="B.培训与学员管理实行计算机操作,部分业务可实现信息化管理" value="B"></el-option>
                            <el-option label="C.培训与学员实行信息化软件管理,主要业务实现信息化管理" value="C"></el-option>
                            <el-option label="D.建有培训与学员管理信息系统,基本实现信息化管理" value="D"></el-option>
                            <el-option label="E.建有培训与学员管理系统，实现远程教学与管理,实现服务全过程信息化管理" value="E"></el-option>
                        </el-select>
                    </el-form-item>
                    <div class="bigTitle">八、材料归档</div>
                    <el-form-item label="29.材料归档率达（%）：" prop="29">
                        <el-input v-model="ruleForm[29]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">九、客户投诉记录及处理</div>
                    <el-form-item label="30.是否设有投诉电话：" prop="30">
                        <el-radio-group v-model="ruleForm[30]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="31.接到投诉到介入处理再到反馈当事人处理结果所需时间（天）：" prop="31">
                        <el-input v-model="ruleForm[31]" placeholder="请输入"></el-input>
                    </el-form-item>

                    <el-form-item label="32.投诉及处理情况记录保存年限（年）：" prop="32">
                        <el-input v-model="ruleForm[32]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="  33.是否有投诉及处理情况记录" prop="33">
                        <el-radio-group v-model="ruleForm[33]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>

                </div>
                <div class="dialogformBottomBtnBox" v-if="!result">
                    <el-button type="primary" @click="saveForm" class="submitBtn">保存</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')" class="submitBtn">提交</el-button>
                    <el-button @click="cancelForm" class="cancelBtn">关闭</el-button>
                </div>
                <div class="dialogformBottomBtnBox" v-else>
                    <el-button @click="cancelForm" class="cancelBtn">关闭</el-button>
                </div>
            </el-form>

        </div>
    </div>
</template>
<script>
import { httpService } from "@/service/httpService";
export default {
    props: ['saveId', 'result'],
    data() {
        return {
            ruleForm: {
                1: '',
                2: '',
                3: '',
                4: '',
                5: '',
                6: '',
                7: '',
                8: '',
                9: '',
                10: '',
                11: '',
                12: '',
                13: '',
                14: '',
                15: '',
                16: '',
                17: '',
                18: '',
                19: '',
                20: '',
                21: '',
                22: '',
                23: '',
                24: '',
                25: '',
                26: '',
                27: '',
                28: "",
                29: '',
                30: '',
                31: '',
                32: '',
                33: '',
            },
            rules: {
                // 正整数
                1: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                2: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],

                3: [
                    { required: true, message: '请选择', trigger: 'change' },
                ],
                4: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                // 小数
                5: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                6: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                7: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                8: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                // 多选
                9: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                10: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                11: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                12: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                13: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                14: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                15: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                16: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                17: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                18: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                19: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                20: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                21: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                22: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                23: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                24: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                25: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                26: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                27: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                28: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                29: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                30: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                31: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                32: [

                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                33: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
            },
        }
    },
    created() {
        this.yetData()
    },
    methods: {
         saveForm() {
            let NewDataList = []
            for (const key in this.ruleForm) {
                let obj = {}
                obj.serialNumber = key;
                obj.evaluateValue = this.ruleForm[key]
                NewDataList.push(obj)
            }
            httpService.saveB(this.saveId, NewDataList).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.$emit('getyetServiceFn')
                }
            })
        },
        // 提交
        submitForm(formName) {
            // 保存不通过validate检验
            this.$refs[formName].validate((valid, obj) => {
                if (valid) {
                    let NewDataList = []
                    // this.ruleForm[28] = this.ruleForm[28].join(',')
                    for (const key in this.ruleForm) {
                        let obj = {}
                        obj.serialNumber = key;
                        obj.evaluateValue = this.ruleForm[key]
                        NewDataList.push(obj)
                    }
                    httpService.addScore(this.saveId,NewDataList).then(res => {
                        if (res.code == 200) {
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            this.$emit('getyetServiceFn')
                        }
                    })
                } else {
                    let arr = []
                    for (const key in obj) {
                        if (Object.hasOwnProperty.call(obj, key)) {
                            let ele = key + '题、'
                            arr.push(ele)
                        }
                    }
                    let str = arr.join('')
                    this.$message.error(`${str}未填写，请检查！`);
                    return false;
                }
            });
        },

        cancelForm() {
            this.$emit('getyetServiceFn')
        },
        // 回填表单数据
        yetData() {
              httpService.getCorpIndicatorOption(this.saveId).then(res => {
                if (res.code == 200) {
                    if (res.result.length != 0) {
                        let obj = {}
                        for (const key in res.result) {
                            obj[res.result[key].serialNumber] = res.result[key].evaluateValue
                        }
                        this.ruleForm = obj
                        // this.ruleForm[28] = this.ruleForm[28].split(',')
                    }
                }
            })
        },
    }


}
</script>
<style lang="less" scoped>
.mainbusinessModal6Warp {
}
</style>


